import { render, staticRenderFns } from "./NoteSystem.vue?vue&type=template&id=8294d77e&scoped=true"
import script from "./NoteSystem.vue?vue&type=script&lang=js"
export * from "./NoteSystem.vue?vue&type=script&lang=js"
import style0 from "./NoteSystem.vue?vue&type=style&index=0&id=8294d77e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8294d77e",
  null
  
)

export default component.exports